import axios from "axios";
export async function getProxyUser(address) {
  const resp = await axios.post("https://bridge.mvm.dev/users", {
    public_key: address
  });
  return resp.data.user;
}
export async function getProxyUserContract(address) {
  var _user$contract;

  const user = await getProxyUser(address);
  return (_user$contract = user === null || user === void 0 ? void 0 : user.contract) !== null && _user$contract !== void 0 ? _user$contract : "";
}
export async function getExtra(payload) {
  const resp = await axios.post("https://bridge.mvm.dev/extra", payload);
  const extra = resp.data.extra;
  return "0x" + extra;
}
export async function getTokenList(address) {
  const resp = await axios.get("https://scan.mvm.dev/api", {
    params: {
      action: "tokenlist",
      address,
      module: "account"
    }
  });
  return resp.data.result;
}
export default {
  getExtra,
  getProxyUser,
  getProxyUserContract,
  getTokenList
};